import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { useEffect, useState } from 'react';
// @mui
import {
    Card,
    Table,
    Stack,
    Paper,
    Button,
    Popover,
    TableRow,
    MenuItem,
    TableBody,
    TableCell,
    Container,
    Typography,
    IconButton,
    TableContainer,
    TablePagination,
    Dialog,
    DialogTitle,
    DialogContent,
    Grid,
    TextField,
    Autocomplete,
    FormControl,
    Select,
} from '@mui/material';
// components
// sections
import Iconify from 'src/components/iconify';
import Scrollbar from 'src/components/scrollbar/Scrollbar';
import '../../Common_css/style.css';
import uploadIcon from '../../components/images/tshirt.png'
import { deleteData, formPostData, getData, patchData, patchFormData, postData } from 'src/webService/webService';
import { toast, ToastContainer } from 'react-toastify';
import deleteIcon from '../../components/icons/remove.png';
import { useNavigate } from 'react-router-dom';
import Loader from '../Loader/Loader';


export default function Categories() {

    const [openModal, setOpenModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [title, setTitle] = useState('');
    const [priority, setPriority] = useState(0);
    const [parentCategory, setParentCategory] = useState();
    const [categoryImage, setCategoryImage] = useState(null);
    const [open, setOpen] = useState(null);
    const [action, setAction] = useState('');
    const [Categories, setCategories] = useState([]);
    const [categoriesArray, setCategoriesArray] = useState([]);
    const [categoryName, setCategoryName] = useState('');
    const [selectedCategory, setSelectedCategory] = useState(null);
    const Token = sessionStorage.getItem('Token');
    const [id, setId] = useState('');
    const [limit, setLimit] = useState(10);
    const [status, setStatus] = useState('category');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1)
    const [TotalItems, setTotalItems] = useState(null);
    const [loading, setLoading] = useState(false);
    const [previewVideo, setPreviewVideo] = useState(null);
    const [profileIntroVideo, setProfileIntroVideo] = useState('');
    const [previewFile, setPreviewFile] = useState(null);
    const [fileType, setFileType] = useState(null);

    const handleVideoChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const url = URL.createObjectURL(file);
            setPreviewFile(url);
            setProfileIntroVideo(file);
            setFileType(file.type.startsWith("image") ? "image" : "video");
        }
    };


    const handleLimitChange = (event) => {
        setCurrentPage(1);
        setLimit(event.target.value);
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        debugger;
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };


    const handleOpenModal = () => {
        setOpenModal(true);
    }

    const handleOpenDeleteModal = () => {
        setOpenDeleteModal(true);
    }

    const handleDeleteClose = () => {
        setOpenDeleteModal(false);
        handleCloseMenu();
    }

    const handleClose = () => {
        setTitle('');
        setPriority(0);
        setParentCategory('');
        setCategoryImage('');
        setPreview(initialImage)
        setOpenModal(false);
        handleCloseMenu();
        setPreviewVideo('');
        setPreviewFile('');
    }

    const handleCloseMenu = () => {
        setOpen(null);
    };

    const handleOpenMenu = (event, id) => {
        setOpen(event.currentTarget);
        setId(id)
    };

    const getCategoryData = async () => {
        debugger;
        setLoading(true);
        const params = {
            page: currentPage,
            per_page: limit,
        }
        console.log(params, "params");
        try {
            const res = await getData('categories', params, Token);
            if (res.status === 200) {
                console.log(res.data, "res.data");
                setCategories(res.data);
                setCategoriesArray(res.data);
                setCategoryName('');
                setSelectedCategory(null);
                setTotalItems(res?.total);
                setTotalPages(res?.last_page);
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        } finally {
            setLoading(false); // Stop loader after API completes
        }
        getCategoryDataArray();
    }


    const getCategoryDataArray = async (page) => {
        const params = {
            // page: page,
            // per_page: limit,
            all: 1
        }
        try {
            const res = await getData('categories', params, Token);
            if (res.status === 200) {
                console.log(res.data, "res.data");
                // setCategories(res.data);
                setCategoriesArray(res.data);
                // setCategoryName('');
                // setTotalItems(res?.total)
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        }
    }

    useEffect(() => {
        if(status=='subCategory'){
            getCategoryById(selectedCategory);
        } else {
            getCategoryData();
        }
    }, [limit, currentPage])

    useEffect(() => {
        selectedCategory != null && getCategoryById(selectedCategory);
    }, [selectedCategory])


    const navigate = useNavigate();

    const getFileFormat = (url) => {
        const parts = url.split(".");
        return parts[parts.length - 1].toLowerCase(); // returns 'png'
    };

    const getCategoryById = async (id) => {
        debugger;
        try {
            const params = {
                page: currentPage,
                per_page: limit,
            };
            if (status === 'category') {
                const res = await getData(`categories/${id}`, params, Token);
                setTitle(res?.name);
                setPriority(res?.priority);
                setParentCategory(res?.parent);
                setPreview(res?.thumbnail);
                if(res?.advertisement && res?.advertisement!=null) {
                    setPreviewFile(res?.advertisement);
                    const format = getFileFormat(res?.advertisement);
                    if(format === 'mp4') {
                        setFileType('video')
                    } else {
                        setFileType('image')
                    }
                }
            } else if (status === 'subCategory') {
                params.category = id;
                const res = await getData(`categories`, params, Token);
                setCategoryName(res?.name);
                setCategories(res?.data);
                setTotalItems(res.total);
                setTotalPages(res.last_page);
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        }
    }

    const deleteCategory = async () => {
        try {
            const res = await deleteData(`categories/${id}`, Token);
            getCategoryData(currentPage);
            handleDeleteClose();
            handleCloseMenu();
            // toast.success('category deleted successfully')
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        }
    }

    const handleChange = (event, status) => {
        debugger
        if (status === 'parentCategory') {
            const selectedEvent = event;
            const filteredEvent = categoriesArray?.find((item) => item === selectedEvent);
            setParentCategory(filteredEvent._id);
        }
    }

    const initialImage = uploadIcon;
    const [preview, setPreview] = useState(initialImage);

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setPreview(URL.createObjectURL(file));
            setCategoryImage(file)
        }
    };

    const handleSubmit = () => {
        debugger;
        const formData = new FormData();
        if (categoryImage === null) {

        } else {
            formData.append("thumbnail", categoryImage);
        }
        if (profileIntroVideo === '') {

        } else {
            formData.append("advertisement", profileIntroVideo);
        }
        formData.append("name", title);
        formData.append("priority", priority);
        formData.append("parent", parentCategory || '');
        console.log(formData);
        if (action === 'Edit') {
            patchFormData(`categories/${id}`, formData, Token)
                .then((res) => {
                    if (categoryName === '') {
                        getCategoryData(currentPage);
                    } else {
                        setStatus('subCategory');
                        setSelectedCategory(res.parent);
                    }
                    handleClose();
                    toast.success('Category updated successfully');
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        } else {
            formPostData("categories", formData, Token)
                .then((res) => {
                    getCategoryData(currentPage);
                    handleClose();
                    toast.success('Category Added successfully');
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        }

    };


    console.log(parentCategory, 'parentCategory');



    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <>
                    <ToastContainer position="top-right" />
                    <Helmet>
                        <title> Categories</title>
                    </Helmet>

                    <div className='p-0'>
                        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                            <Typography variant="h4" className='title-color' gutterBottom>
                                {categoryName === '' ? (
                                    <></>
                                ) : (
                                    <Iconify className='backIcon pointer' onClick={getCategoryData} icon="eva:arrow-back-fill" />
                                )}
                                {categoryName} Categories
                            </Typography>
                            <Button variant="contained" className='Button' onClick={handleOpenModal} startIcon={<Iconify icon="eva:plus-fill" />}>New Category</Button>
                        </Stack>


                        <Card className='card-bg'>
                            {/* <Scrollbar> */}
                            <TableContainer style={{ height: "450px", overflowY: "scroll" }}>
                                <div className='row my-2 mx-1'>
                                    {Categories?.map((item, index) => (
                                        <div className='col-lg-3' key={index}>
                                            <div className='cardLayout'>
                                                <IconButton
                                                    size="large"
                                                    color="inherit"
                                                    style={{ position: 'absolute', top: '14px', right: '14px', padding: '6px', background: '#d0e1e9', border: '1px solid white' }}
                                                    onClick={(event) => {
                                                        setStatus('category');
                                                        setSelectedCategory(item?._id);
                                                        handleOpenMenu(event, item?._id);
                                                    }}
                                                >
                                                    <Iconify icon={"eva:more-vertical-fill"} />
                                                </IconButton>
                                                <div className='p-3'>
                                                    <img src={item?.thumbnail} />
                                                </div>
                                                <h5 className='px-3 pt-2 pb-1 text-center'>{item?.name}</h5>
                                                {categoryName === '' ? (
                                                    <div className='d-flex justify-content-center'>
                                                        <Button style={{ fontSize: '12px' }} variant="contained" className='Button' onClick={(e) => {
                                                            setStatus('subCategory');
                                                            setSelectedCategory(item?._id);
                                                        }}>
                                                            {item?.subCategoryCount} View Sub Category
                                                        </Button>
                                                    </div>
                                                ) : (
                                                    <>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </TableContainer>
                            <div className="d-flex flex-wrap justify-content-end m-3">
                                <FormControl variant="outlined" size="small" style={{ width: "7%" }}>
                                    <Select
                                        labelId="limit-label"
                                        id="limit-select"
                                        value={limit}
                                        onChange={handleLimitChange}
                                    >
                                        <MenuItem value={10}>10</MenuItem>
                                        <MenuItem value={20}>20</MenuItem>
                                        <MenuItem value={30}>30</MenuItem>
                                        <MenuItem value={TotalItems}>All</MenuItem>
                                    </Select>
                                </FormControl>
                                <Button onClick={handlePrevPage} disabled={currentPage === 1}>
                                    <Iconify icon={"grommet-icons:previous"} />
                                </Button>
                                <Button
                                    onClick={handleNextPage}
                                    disabled={currentPage === totalPages}
                                >
                                    <Iconify icon={"grommet-icons:next"} />
                                </Button>
                            </div>
                            <Popover
                                open={Boolean(open)}
                                anchorEl={open}
                                onClose={handleCloseMenu}
                                anchorOrigin={{ vertical: "top", horizontal: "left" }}
                                transformOrigin={{ vertical: "top", horizontal: "right" }}
                                PaperProps={{
                                    sx: {
                                        p: 1,
                                        width: 160,
                                        "& .MuiMenuItem-root": {
                                            px: 1,
                                            typography: "body2",
                                            borderRadius: 0.75,
                                        },
                                    },
                                }}
                            >
                                <MenuItem
                                    onClick={() => {
                                        setAction("Edit");
                                        handleOpenModal();
                                    }}
                                >
                                    <Iconify icon={"eva:edit-fill"} sx={{ mr: 2 }} />
                                    Edit
                                </MenuItem>
                                <MenuItem
                                    onClick={() => {
                                        setAction("View");
                                        handleOpenModal();
                                    }}
                                >
                                    <Iconify icon={"raphael:view"} sx={{ mr: 2 }} />
                                    View
                                </MenuItem>
                                <MenuItem
                                    sx={{ color: "error.main" }}
                                    onClick={() => {
                                        handleOpenDeleteModal();
                                    }}
                                >
                                    <Iconify icon={"eva:trash-2-outline"} sx={{ mr: 2 }} />
                                    Delete
                                </MenuItem>
                            </Popover>
                            {/* </Scrollbar> */}
                        </Card>

                    </div >
                    <Dialog open={openModal} onClose={handleClose} maxWidth="sm" fullWidth>
                        <div className="d-flex justify-content-between">
                        <DialogTitle>Add Categories</DialogTitle>
                        <Iconify icon='material-symbols:close-rounded' sx={{ margin: '12px',cursor: "pointer"}} onClick={handleClose} />
                        </div>
                        <DialogContent>
                            <Grid container spacing={1}>
                                <Grid item xs={12} className='mt-3'>
                                    <div style={{ textAlign: "center", padding: '12px', border: '1px solid #e3e3e3', borderRadius: '10px' }}>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            id="fileInput"
                                            style={{ display: "none" }}
                                            onChange={handleImageChange}
                                        />
                                        <label htmlFor="fileInput">
                                            <img
                                                src={preview}
                                                alt="Uploaded"
                                                style={{
                                                    width: "300px",
                                                    height: "230px",
                                                    objectFit: "contain",
                                                    cursor: "pointer",
                                                    borderRadius: "10px",
                                                }}
                                            />
                                            <p className='mb-0' style={{ fontSize: '12px' }}>Upload thumbnail image</p>
                                        </label>
                                    </div>
                                </Grid>
                                <Grid item xs={12} className='mt-3'>
                                    <div style={{ textAlign: "center", padding: '12px', border: '1px solid #e3e3e3', borderRadius: '10px' }}>

                                        <input
                                            type="file"
                                            accept="video/*,image/*"
                                            id="videoInput"
                                            style={{ display: "none" }}
                                            onChange={handleVideoChange}
                                        />
                                        <label htmlFor="videoInput">
                                            {previewFile ? (
                                                fileType === "image" ? (
                                                    <img
                                                        src={previewFile}
                                                        alt="Preview"
                                                        style={{
                                                            width: "300px",
                                                            height: "220px",
                                                            objectFit: "contain",
                                                            cursor: "pointer",
                                                            borderRadius: "10px",
                                                        }}
                                                    />
                                                ) : (
                                                    <video
                                                        src={previewFile}
                                                        controls
                                                        style={{
                                                            width: "300px",
                                                            height: "220px",
                                                            objectFit: "contain",
                                                            cursor: "pointer",
                                                            borderRadius: "10px",
                                                        }}
                                                    />
                                                )
                                            ) : (
                                                <div style={{
                                                    width: "300px",
                                                    height: "230px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    backgroundColor: "#f0f0f0",
                                                    borderRadius: "10px",
                                                    cursor: "pointer"
                                                }}>
                                                    <p style={{ fontSize: '14px', color: '#666' }}>Click to upload advertisement video or image</p>
                                                </div>
                                            )}
                                            <p className='mb-0' style={{ fontSize: '12px' }}>Edit Advertisement</p>
                                        </label>
                                    </div>
                                </Grid>
                                <Grid item xs={10} className='mt-3'>
                                    <TextField
                                        className="w-100"
                                        id="outlined-basic"
                                        // InputProps={{
                                        //     readOnly: action === "View",
                                        // }}
                                        value={title}
                                        onChange={(e) => setTitle(e.target.value)}
                                        label="Title *"
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={2} className='mt-3'>
                                    <TextField
                                        className="w-100"
                                        id="outlined-basic"
                                        value={priority}
                                        onChange={(e) => setPriority(e.target.value)}
                                        label="Priority"
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} className='mt-3'>
                                    <Autocomplete
                                        options={categoriesArray || []}
                                        getOptionLabel={(option) => option.name}
                                        value={categoriesArray?.find((item) => item?._id === parentCategory) || null}
                                        onChange={(event, newValue) => handleChange(newValue ? newValue : null, 'parentCategory')}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Parent-Category" variant="outlined" />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                            <div className='mt-4 d-flex justify-content-end'>
                                <Button variant="contained" className='Button' onClick={handleSubmit}>
                                    Submit
                                </Button>
                            </div>
                        </DialogContent>
                    </Dialog>
                    <Dialog open={openDeleteModal} onClose={handleDeleteClose} maxWidth="sm" fullWidth>
                        <DialogContent className='p-5'>
                            <div>
                                <div className='d-flex justify-content-center'>
                                    <img src={deleteIcon} width='10%' />
                                </div>
                                <h4 className='text-center mt-4'>Confirm deletion?</h4>
                                <p className='text-center'>Data will be lost forever.</p>
                                <Button variant="contained" className='Button w-100 mt-3 shadow-none' onClick={(e) => deleteCategory()}>
                                    Yes
                                </Button>
                                <Button variant="outlined" className='w-100 mt-3' onClick={(e) => handleDeleteClose()} >
                                    No
                                </Button>
                            </div>
                        </DialogContent>
                    </Dialog>
                </>
            )}
        </>
    )
}